import { Routes } from "@angular/router";
import { MapContainerComponent } from "./modules/map/map-container/map-container.component";
import { canLoadSpatialAnalysisGuard } from "./shared/guards/can-load-spatial-analysis.guard";

export const routes: Routes = [
  {
    path: "",
    title: "Accumate",
    component: MapContainerComponent,
    children: [
      {
        path: "real-estate",
        loadChildren: () => import("./modules/real-estate/real-estate.routes").then(m => m.realEstateRoutes)
      },
      {
        path: "portfolio",
        loadChildren: () => import("./modules/real-estate/portfolio-real-estate.routes").then(m => m.portfolioRealEstateRoutes)
      },
      {
        path: "spatial-analysis",
        loadChildren: () => import("./modules/spatial-analysis/spatial-analysis.routes").then(m => m.spatialAnalysisRoutes),
        canActivate: [canLoadSpatialAnalysisGuard]
      }
    ]
  },
  {
    path: "settings",
    loadChildren: () => import("./modules/option/option.routes").then(m => m.optionRoutes)
  },
  {
    path: "portfolio-overview",
    loadComponent: () =>
      import("./modules/portfolio-list-overview/components/portfolio-overview/portfolio-overview.component").then(
        m => m.PortfolioOverviewComponent
      )
  }
];
